var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 7.33325H25.3334V20.6666H6.66669V7.33325Z",
    fill: "url(#paint0_linear_887_4788)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3334 3.33325H6.66669C4.45755 3.33325 2.66669 5.12411 2.66669 7.33325V24.6666H25.3334C27.5425 24.6666 29.3334 22.8757 29.3334 20.6666V3.33325ZM25.3334 7.33325H6.66669V20.6666H25.3334V7.33325ZM11.3334 13.9999C11.3334 11.7908 13.1242 9.99992 15.3334 9.99992H16.6667C18.8758 9.99992 20.6667 11.7908 20.6667 13.9999C20.6667 16.2091 18.8758 17.9999 16.6667 17.9999H15.3334C13.1242 17.9999 11.3334 16.2091 11.3334 13.9999ZM14 13.9999C14 13.2635 14.597 12.6666 15.3334 12.6666H16.6667C17.4031 12.6666 18 13.2635 18 13.9999C18 14.7363 17.4031 15.3333 16.6667 15.3333H15.3334C14.597 15.3333 14 14.7363 14 13.9999Z",
    fill: "#FAB215"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 24.6665H6.66669V27.3332H8.00002C9.47278 27.3332 10.6667 26.1393 10.6667 24.6665ZM25.3334 24.6665H21.3334V27.3332H22.6667C24.1394 27.3332 25.3334 26.1393 25.3334 24.6665Z",
    fill: "#FAB215"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4788",
    x1: 6.66669,
    y1: 7.33325,
    x2: 25.3334,
    y2: 20.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg20);
export default __webpack_public_path__ + "static/media/20.02094d97c685cc3f9f34f916d38ee5f0.svg";
export { ForwardRef as ReactComponent };